module.exports = __webpack_public_path__ + "img/mrtx.1271e4db.png";